export const appDetails = {
  "crm": {
    title: "Odoo CRM",
    category: "Sales",
    icon: "crm",
    heroText: "made customer-centric",
    heroSubtext: "Track leads, close opportunities, and get accurate forecasts. Focus on your customers, Odoo handles the rest.",
    heroImage: "/odoo/apps/crm/crm_hero.webp",
    fallbackIcon: "🎯",
    sections: [
      {
        type: "split-content",
        title: "Intelligent Pipeline Management",
        items: [
          {
            text: "Your leads are centralized in one simple, drag-and-drop Kanban board. Schedule follow-ups, calls, and meetings in a single click.",
            image: "/odoo/unsplash/app/crm-pipeline.jpg"
          },
          {
            text: "Get real-time insights and automated forecasting based on your team's historical performance and deal progress.",
            image: "/odoo/unsplash/app/analytics.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Sell 29% Faster with Odoo",
        subtext: "Odoo's automated lead scoring and smart scheduling remove the administrative overhead, letting your sales team focus on what they do best: closing deals.",
        video: "/odoo/videos/business_loop.mp4",
        stats: "2.5x more active conversations"
      },
      {
        type: "split-content",
        title: "Integrated Mailbox & Activity Log",
        items: [
          {
            text: "Send emails, schedule video calls, and record client negotiations directly from the CRM card. Full audit trails ensure perfect team handovers.",
            image: "/odoo/unsplash/app/mailbox.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "Real-time Forecasting", desc: "Instantly see the projected value of your pipeline using AI-powered lead scoring." },
      { title: "Lead Generation", desc: "Convert incoming emails, website contact forms, and chats into leads automatically." },
      { title: "Smart Scheduler", desc: "Automate task creation for follow-ups, calls, and email touchpoints." },
      { title: "Seamless Integration", desc: "Fully connected with Odoo Invoicing, Sales, Sign, and Marketing apps." }
    ]
  },
  "project": {
    title: "Odoo Project",
    category: "Services",
    icon: "project",
    heroText: "organized simply",
    heroSubtext: "Keep track of everything in one place, from the high-level overview down to the granular details of every task.",
    heroImage: "/odoo/apps/project/project_hero.webp",
    fallbackIcon: "📊",
    sections: [
      {
        type: "split-content",
        title: "Agile Project Planning",
        items: [
          {
            text: "Schedule your teams across projects using interactive Gantt charts, resource planning matrices, and dynamic workloads.",
            image: "/odoo/unsplash/app/gantt.jpg"
          },
          {
            text: "Collaborate instantly on tasks with integrated chat, collaborative pads, and automated status reporting.",
            image: "/odoo/unsplash/app/collaboration.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Boost Project Profitability by 18%",
        subtext: "Track employee timesheets, assign billable roles, and get comprehensive financial analytics for each project phase automatically.",
        video: "/odoo/videos/business_loop.mp4", 
        stats: "18% Margin Increase"
      },
      {
        type: "split-content",
        title: "Customer Collaboration Portal",
        items: [
          {
            text: "Grant your clients secure access to a dedicated external portal to view real-time task statuses, download documents, and sign contract milestones.",
            image: "/odoo/unsplash/app/portal.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "Gantt & Kanban Views", desc: "Switch instantly between visual pipeline stages, list lists, calendar timelines, and Gantt charts." },
      { title: "Resource Allocation", desc: "Track employee workloads and instantly reassign tasks to optimize capacity." },
      { title: "Timesheet Integration", desc: "Log hours directly from tasks with a single click, feeding directly into billing." },
      { title: "Customer Portal", desc: "Allow clients access to real-time status, timesheets, and shared document folders." }
    ]
  },
  "accounting": {
    title: "Odoo Accounting",
    category: "Finance",
    icon: "accountant",
    heroText: "made effortless",
    heroSubtext: "Do more in less time. Automate bank feeds, invoice processing, and professional tax reconciliation.",
    heroImage: "/odoo/apps/accounting/accounting_hero.webp",
    fallbackIcon: "🧮",
    sections: [
      {
        type: "split-content",
        title: "Automate 95% of Bank Reconciliation",
        items: [
          {
            text: "Synchronize directly with over 28,000 banks. Odoo automatically matches transaction statements with invoices to save hours of manual reconciliation.",
            image: "/odoo/unsplash/app/banking1.jpg"
          },
          {
            text: "Instantly generate complete, localized financial reports including balance sheets, P&L statements, and tax reconciliation.",
            image: "/odoo/unsplash/app/banking2.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Real-time Financial Health",
        subtext: "Track payables, receivables, and overall profit margins dynamically with customized business intelligence dashboards.",
        video: "/odoo/videos/business_loop.mp4",
        stats: "28,000+ banks supported"
      },
      {
        type: "split-content",
        title: "Professional Customer Billing",
        items: [
          {
            text: "Create polished, professional invoices, support recurring subscription cycles, and receive instant online credit card/bank payments.",
            image: "/odoo/unsplash/app/invoice.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "AI Bill Digitization", desc: "Scan and read vendor bills automatically using high-accuracy optical character recognition." },
      { title: "Multi-Currency Support", desc: "Perform international trades with automatic daily exchange rate updates." },
      { title: "Automated Tax Filings", desc: "Generate compliant tax sheets based on your specific country rules." },
      { title: "Customer Payment Reminders", desc: "Set up automated, polite follow-ups for outstanding invoices." }
    ]
  },
  "accountant": {
    title: "Odoo Accounting",
    category: "Finance",
    icon: "accountant",
    heroText: "made effortless",
    heroSubtext: "Imagine one AI-native Accounting platform for all your financial operations, from reconciliation and expenses to tax returns and real-time reporting.",
    heroImage: "/odoo/apps/accounting/accounting_hero.webp",
    fallbackIcon: "🧮",
    sections: [
      {
        type: "split-content",
        title: "Automate 95% of Bank Reconciliation",
        items: [
          {
            text: "Synchronize directly with over 28,000 banks. Odoo automatically matches transaction statements with invoices to save hours of manual reconciliation.",
            image: "/odoo/unsplash/app/banking1.jpg"
          },
          {
            text: "Instantly generate complete, localized financial reports including balance sheets, P&L statements, and tax closing reports.",
            image: "/odoo/unsplash/app/banking2.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Real-time Financial Health",
        subtext: "Track payables, receivables, and overall profit margins dynamically with customized business intelligence dashboards.",
        video: "/odoo/videos/business_loop.mp4",
        stats: "28,000+ banks supported"
      },
      {
        type: "split-content",
        title: "Professional Customer Billing",
        items: [
          {
            text: "Create polished, professional invoices, support recurring subscription cycles, and receive instant online credit card/bank payments.",
            image: "/odoo/unsplash/app/invoice.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "AI Bill Digitization", desc: "Scan and read vendor bills automatically using high-accuracy optical character recognition." },
      { title: "Multi-Currency Support", desc: "Perform international trades with automatic daily exchange rate updates." },
      { title: "Automated Tax Filings", desc: "Generate compliant tax sheets based on your specific country rules." }
    ]
  },
  "timesheet": {
    title: "Odoo Timesheets",
    category: "Services",
    icon: "timesheet_grid",
    heroText: "tracked instantly",
    heroSubtext: "The fastest, most intuitive timesheet tracking tool for teams on the go. Available across desktop and mobile devices.",
    heroImage: "/odoo/apps/timesheets/timesheets_hero.webp",
    fallbackIcon: "⏱️",
    sections: [
      {
        type: "split-content",
        title: "Workforce Analytics & Capacity Planning",
        items: [
          {
            text: "Monitor project progress, log task hours, and analyze resource capabilities in real-time.",
            image: "/odoo/unsplash/app/timesheets.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Track Time from Anywhere",
        subtext: "Launch the Odoo timer on your browser, desktop app, or mobile device with a single click. Keep time entries synced 100% offline.",
        video: "/odoo/videos/business_loop.mp4", 
        stats: "100% Mobile Synced"
      },
      {
        type: "split-content",
        title: "Instant Invoicing Integration",
        items: [
          {
            text: "Automatically convert logged timesheet hours into professional customer invoice items. No manual tracking, no double entries.",
            image: "/odoo/unsplash/app/invoice.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "One-Click Timer", desc: "Launch tracking instantly from your desktop dashboard, browser extension, or mobile application." },
      { title: "Accurate Invoicing", desc: "Automatically feed logged billable hours into client invoices without manual entry." },
      { title: "Grid Multi-entry", desc: "Manage bulk entries in a clean, weekly grid layout with hotkey shortcuts." }
    ]
  },
  "timesheet_grid": {
    title: "Odoo Timesheets",
    category: "Services",
    icon: "timesheet_grid",
    heroText: "tracked instantly",
    heroSubtext: "The fastest, most intuitive timesheet tracking tool for teams on the go. Available across desktop and mobile devices.",
    heroImage: "/odoo/apps/timesheets/timesheets_hero.webp",
    fallbackIcon: "⏱️",
    sections: [
      {
        type: "split-content",
        title: "Workforce Analytics & Capacity Planning",
        items: [
          {
            text: "Monitor project progress, log task hours, and analyze resource capabilities in real-time.",
            image: "/odoo/unsplash/app/timesheets.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Track Time from Anywhere",
        subtext: "Launch the Odoo timer on your browser, desktop app, or mobile device with a single click. Keep time entries synced 100% offline.",
        video: "/odoo/videos/business_loop.mp4", 
        stats: "100% Mobile Synced"
      },
      {
        type: "split-content",
        title: "Instant Invoicing Integration",
        items: [
          {
            text: "Automatically convert logged timesheet hours into professional customer invoice items. No manual tracking, no double entries.",
            image: "/odoo/unsplash/app/invoice.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "One-Click Timer", desc: "Launch tracking instantly from your desktop dashboard, browser extension, or mobile application." },
      { title: "Accurate Invoicing", desc: "Automatically feed logged billable hours into client invoices without manual entry." }
    ]
  },
  "documents": {
    title: "Odoo Documents",
    category: "Productivity",
    icon: "documents",
    heroText: "paperless & secure",
    heroSubtext: "Ditch the paper cabinets. Store, tag, index, and organize all business records in a highly secure digital environment.",
    heroImage: "/odoo/apps/documents/documents_hero.webp",
    fallbackIcon: "📁",
    sections: [
      {
        type: "split-content",
        title: "Fully Digital Workflow Orchestration",
        items: [
          {
            text: "Process documents with built-in AI rules: automatically split PDFs, assign tasks to workers, and trigger payment cycles.",
            image: "/odoo/unsplash/app/documents.jpg"
          }
        ]
      },
      {
        type: "video-stats",
        title: "Unmatched Document Productivity",
        subtext: "Scan any physical sheet using the integrated OCR engine, tag metadata categories automatically, and search folders in milliseconds.",
        video: "/odoo/videos/business_loop.mp4", 
        stats: "99% OCR Accuracy"
      },
      {
        type: "split-content",
        title: "E-Signature & File Review Cycles",
        items: [
          {
            text: "Send files out for signatures directly from your secure Document vault in one click. Fully traceable audit trails integrated.",
            image: "/odoo/unsplash/app/esign.jpg"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "Drag-and-Drop Indexing", desc: "Upload multi-page documents, drag sheets to split, and tag categories in seconds." },
      { title: "E-mail Integration", desc: "Assign unique mailboxes for vendors to send invoices directly into your document pipeline." },
      { title: "Advanced Permissions", desc: "Securely control viewing, editing, and downloading access using advanced user roles." }
    ]
  },
  "sign": {
    title: "Odoo Sign",
    category: "Productivity",
    icon: "sign",
    heroText: "signed in a click",
    heroSubtext: "Send, sign, and manage unlimited agreements for free. Experience the world's most intuitive eSign workflow, built for speed and legal compliance.",
    heroImage: "/odoo/apps/sign/sign_hero.webp",
    fallbackIcon: "✍️",
    sections: [
      {
        type: "split-content",
        title: '<span class="x_wd_red_highlight_03">Simplify</span> it, <br class="d-none d-lg-block"> <span class="x_wd_yellow_highlight_03">automate</span> it, <br class="d-none d-lg-block"> <span class="x_wd_green_highlight_01">sign</span> it',
        items: [
          {
            text: "<strong>Drag and drop editable and mandatory fields.</strong> Automate repetitive completion by using pre-filled templates. Write your document only once and be more productive!",
            image: "/odoo/apps/sign/simplify_signing.webp"
          },
          {
            text: "Collect signatures in seconds. Your clients can access and review documents on any device and sign them electronically with just a few clicks.",
            image: "/odoo/unsplash/app/analytics.jpg"
          }
        ]
      },
      {
        type: "split-content",
        title: 'Your signing process<br> under <span class="x_wd_blue_highlight_01">control</span>',
        items: [
          {
            text: "<strong>Track document status.</strong> Swiftly send signature requests and reminders to recipients, and keep an eye on the progress of your contracts.",
            image: "/odoo/apps/sign/control.webp"
          }
        ]
      }
    ],
    featuresGrid: [
      { title: "Adopt your signature", desc: "Signers can draw with their mouse or finger, load a scan, or use an automatic e-signature." },
      { title: "100% Legal & Secure", desc: "Fully compliant with eIDAS in Europe, the US ESIGN Act, and India's ITA & ICA laws." },
      { title: "Instant Validation", desc: "Validate form entries and digital sign fields in one single click." },
      { title: "Cryptographic Traceability", desc: "Secure activity logging via comprehensive, secure, and transparent audit logs." },
      { title: "SMS Authentication", desc: "Deliver one-time codes by SMS to verify signatories securely." },
      { title: "Automated Reminders", desc: "Configure automatic reminders to guide clients through the signing process." }
    ]
  }
};
